import { AppRoutes } from '@/routes/routes'
import { ErrorBoundary } from '@/components/feedback/error-boundary'

function App() {
  return (
    <ErrorBoundary>
      <AppRoutes />
    </ErrorBoundary>
  )
}

export default App
